import React, { useContext, useState } from 'react'
import './HomeNavLinks.css'
import { NavLink, useNavigate, Link } from 'react-router-dom'
import { AuthContext } from '../../context/auth-context'

const HomeNavLinks = (props) => {
	const auth = useContext(AuthContext)
	const [loggedOut, setLoggedOut] = useState(false)
	//
	let navigate = useNavigate()

	const propsString = props.leagueId

	//
	let statsId
	if (auth.statsIsLoggedIn) {
		const test = localStorage.getItem('id')
		statsId = test
	}

	let page

	if (auth.isLoggedIn) {
		page = '/admin/team/current'
	} else {
		page = '/admin/login'
	}

	const logoutStuff = () => {
		console.log('inside logoutStuff')
		setLoggedOut(true)
	}

	if (loggedOut) {
		console.log('user is logged out')
		navigate('/')
		auth.statsLogout()
	}

	return (
		<ul className='home-nav-links'>
			{props.leagueId && (
				<li>
					<NavLink to={`/league/schedule/${propsString}`}>SCHEDULE</NavLink>
				</li>
			)}
			{!props.leagueId && (
				<li>
					<NavLink to={'/schedule'}>SCHEDULE</NavLink>
				</li>
			)}
			{props.leagueId && (
				<li>
					<NavLink to={`/league/${propsString}`}>STATS & STANDINGS</NavLink>
				</li>
			)}
			{auth.statsIsLoggedIn && (
				<li style={{ width: 'max-content' }}>
					<NavLink to={'/statsandstandings'}>PLAYER STATS</NavLink>
				</li>
			)}
			{!auth.statsIsLoggedIn && (
				<li style={{ width: 'max-content' }}>
					<NavLink to={'/admin/badgerslogin'}>PLAYER STATS</NavLink>
				</li>
			)}
			{auth.statsIsLoggedIn && (
				<li style={{ width: 'max-content' }}>
					<NavLink to={'/history'}>PREVIOUS SEASONS</NavLink>
				</li>
			)}
			{auth.statsIsLoggedIn && (
				<li>
					<button onClick={logoutStuff} style={{ border: 'none' }}>
						LOGOUT
					</button>
				</li>
			)}
			<li>
				<a href='/'>HOME</a>
			</li>
			<li>
				<NavLink to={page}>ADMIN</NavLink>
			</li>
		</ul>
	)
}

export default HomeNavLinks
